module.exports = __webpack_public_path__ + "img/14.dabdfe99.jpg";